import { provideChameleonDesignSystem } from '../provideChameleonDesignSystem';
import { chameleonSkeleton } from './Skeleton.definition';
export function registerCustom(prefix, node) {
    return provideChameleonDesignSystem({ prefix, node }).register(chameleonSkeleton({ prefix }));
}
